/**
 * @generated SignedSource<<5a24aa548d8e72ff96329f64fa7069bd>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSnippet_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Avatar_iHaveAvatar"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "797221209e499ed78fa11a8fb83555fc";
export default node;
